// src/context/EnseignantDrawerContext.jsx
import { createContext, useContext, useState } from "react";

const EnseignantDrawerContext = createContext(null);

// ─── PROVIDER ──────────────────────────────────────────────────────────
// Fournit l'état du drawer à toute l'arborescence Enseignant, pour que
// n'importe quelle page (ENAccueil, ENFaireAppel, ...) puisse l'ouvrir
// depuis son propre header, exactement comme côté Parent.
export function EnseignantDrawerProvider({ children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const openDrawer = () => setDrawerOpen(true);
  const closeDrawer = () => setDrawerOpen(false);
  const toggleDrawer = () => setDrawerOpen((prev) => !prev);

  return (
    <EnseignantDrawerContext.Provider
      value={{ drawerOpen, openDrawer, closeDrawer, toggleDrawer }}
    >
      {children}
    </EnseignantDrawerContext.Provider>
  );
}

// ─── HOOK ──────────────────────────────────────────────────────────────
export function useEnseignantDrawer() {
  const ctx = useContext(EnseignantDrawerContext);
  if (!ctx) {
    throw new Error(
      "useEnseignantDrawer doit être utilisé à l'intérieur d'un EnseignantDrawerProvider"
    );
  }
  return ctx;
}